// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PVerticalLeftOutlinedSvg from "@fishx/icons-svg/es/asn/PVerticalLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var PVerticalLeftOutlined = function PVerticalLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PVerticalLeftOutlinedSvg
  }));
};

PVerticalLeftOutlined.displayName = 'PVerticalLeftOutlined';
export default React.forwardRef(PVerticalLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PVerticalLeftOutlined.js
// module id = 3728
// module chunks = 0